import { render, staticRenderFns } from "./UserStatusSettings.vue?vue&type=template&id=3f3b4c34"
import script from "./UserStatusSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./UserStatusSettings.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports